/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="../login/login.model.ts" />

module Eseebase {
    export class NavigationController implements angular.IController {
        public user: UserModel;
        public selectedCompany: CompanyViewModel;
        public currentLanguage: string;
        public menuActive: boolean;
        public searchActive: boolean;
        public showTooltip: boolean;
        public features: CompanyFeatureList;
        public mapSettings: MapSettings;
        public mapMenu: ActionButtonMenu;

        $onInit = () => { };

        constructor(private $scope: ng.IScope,
                    private userService: UserService,
                    private $window: ng.IWindowService,
                    private $location: ng.ILocationService,
                    private cookiesService: CookiesService,
                    private $route: any,
                    private textService: TextService,
                    private companyService: CompanyService,
                    private organizationSettingsService: OrganizationSettingsService,
                    private organizationService: OrganizationService,
                    private $q: any,
                    private $rootScope: ng.IRootScopeService,
                    private $timeout: ng.ITimeoutService
        ) {
            var vm = this;
            this.menuActive = false;
            this.searchActive = false;
            var culture = this.cookiesService.readCookie('currentLanguage');
            this.currentLanguage = this.getLanguageFromCulture(culture);
            this.loadMapSettings();
            if (window.location.hash.substr(0, '#!/login'.length) == '#!/login' || window.location.hash.substr(0, '#!/newpassword'.length) == '#!/newpassword') {
                return;
            }
            userService.getUser().then((u: UserModel) =>
            {
                if (u.companies == null || u.companies.length == 0) {
                    vm.logOff();
                }
                var companyNumber = this.cookiesService.readCookie('company');
                vm.user = u;
                if (companyNumber != null) {
                    var company = u.companies.filter((val) => val.companyNumber == companyNumber);
                    if (company != null && company.length > 0) {
                        vm.selectedCompany = company[0];
                    }
                }
                if (vm.selectedCompany == null) {
                    vm.selectedCompany = u.companies[0];
                }
            },
                () => vm.user = null);
            organizationSettingsService.getFeatures().then((features: CompanyFeatureList) => vm.features = features);
            organizationSettingsService.getUIStyling();

            $rootScope.$on('start-create-locality', () => {
                if (!vm.searchActive) {
                    vm.searchActive = true;
                    vm.$timeout(() => {
                        document.getElementById('mapSearchInput').focus();
                        vm.showTooltip = true;
                    }, 300);
                }
            });

            $rootScope.$on('end-create-locality', () => {
                vm.closeSearchBox();
            });
            this.mapMenu = new ActionButtonMenu();
            this.mapMenu.items = [
                new ActionButtonMenuItem(this.textService.translate('Map_SatelliteView'), vm.mapSettings.isSattelite, (item: ActionButtonMenuItem) => {
                    vm.mapSettings.isSattelite = item.active;
                    vm.saveMapSettings();
                    vm.$rootScope.$broadcast('map-view-change');
                }),
                new ActionButtonMenuItem(this.textService.translate('Map_ShowBuildingLocalizers'), vm.mapSettings.showBuildingLocalizers, (item: ActionButtonMenuItem) => {
                    vm.mapSettings.showBuildingLocalizers = item.active;
                    vm.saveMapSettings();
                    vm.$rootScope.$broadcast('map-view-change');
                }),
                new ActionButtonMenuItem(this.textService.translate('Map_ShowLandscapeLocalizers'), vm.mapSettings.showLandscapeLocalizers, (item: ActionButtonMenuItem) => {
                    vm.mapSettings.showLandscapeLocalizers = item.active;
                    vm.saveMapSettings();
                    vm.$rootScope.$broadcast('map-view-change');
                }),
                new ActionButtonMenuItem(this.textService.translate('Map_ShowLocalizersWithDrawings'), vm.mapSettings.showLocalizersWithDrawings, (item: ActionButtonMenuItem) => {
                    vm.mapSettings.showLocalizersWithDrawings = item.active;
                    vm.saveMapSettings();
                    vm.$rootScope.$broadcast('map-view-change');
                }),
                new ActionButtonMenuItem(this.textService.translate('Map_ShowLocalizersWithoutDrawings'), vm.mapSettings.showLocalizersWithoutDrawings, (item: ActionButtonMenuItem) => {
                    vm.mapSettings.showLocalizersWithoutDrawings = item.active;
                    vm.saveMapSettings();
                    vm.$rootScope.$broadcast('map-view-change');
                }),
                new ActionButtonMenuItem(this.textService.translate('Map_ShowBuildingBoundries'), vm.mapSettings.showBuildingOverlay, (item: ActionButtonMenuItem) => {
                    vm.mapSettings.showBuildingOverlay = item.active;
                    vm.saveMapSettings();
                    vm.$rootScope.$broadcast('map-view-change');
                }),
                new ActionButtonMenuItem(this.textService.translate('Map_ShowLandscapeBoundries'), vm.mapSettings.showLandscapeOverlay, (item: ActionButtonMenuItem) => {
                    vm.mapSettings.showLandscapeOverlay = item.active;
                    vm.saveMapSettings();
                    vm.$rootScope.$broadcast('map-view-change');
                })
            ];
        }

        private saveMapSettings() {
            this.cookiesService.createCookie('mapSettings', JSON.stringify(this.mapSettings), 720);
        }

        public includeFeedbackModule() {
            return this.features != null && this.features.includeFeedbackModule();
        }

        public getLanguageFromCulture(culture: string) {
            switch (culture) {
                case 'da-DK':
                    return 'DK';
                case 'en-GB':
                    return 'EN';
                case 'de-DE':
                    return 'DE';
                case 'se-SE':
                    return 'SE';
                default:
                    return 'EN';
            }
        }

        public setLanguage(lang)
        {
            if (this.currentLanguage != this.getLanguageFromCulture(lang)) {
                this.cookiesService.createCookie('currentLanguage', lang, 60 * 24 * 365 * 5);
                this.textService.reset();
                BuildingService.tabs = null;
                if (document.getElementById('googleMapsScript') != null) {
                    document.getElementById('googleMapsScript').remove();
                }
                this.$route.reload();
            }
        }
        
        public selectCompany(company: CompanyViewModel) {
            this.selectedCompany = company;
            var companyNumber = this.cookiesService.readCookie('company');
            if (companyNumber != company.companyNumber) {
                this.cookiesService.createCookie('company', company.companyNumber, 60 * 24 * 365 * 5);
                this.cookiesService.deleteCookie('modelFilter');
                var vm = this;
                var promisses = new Array<ng.IPromise<any>>();
                promisses.push(this.organizationSettingsService.getFeatures(true));
                promisses.push(this.organizationSettingsService.getUIStyling(true));
                promisses.push(this.userService.getUser(true));
                this.organizationService.resetOrgUnits();
                this.$q.all(promisses).then(() => {
                    vm.$route.reload()
                });
                this.$rootScope.$broadcast('onCompanySelect');
            }
        }

        public openSearchBox() {
            if (!this.searchActive)
            {
                document.getElementById('mapSearchInput').focus();
                this.searchActive = true;
            }
            else {
                this.closeSearchBox();
            }
        }

        public searchBoxBlur() {
            if (!this.showTooltip && this.searchActive) {
                this.closeSearchBox();
            }
        }

        public closeSearchBox() {
            var vm = this;
            this.showTooltip = false;
            this.$timeout(() => {
                vm.searchActive = false;
                vm.$rootScope.$broadcast('cancel-create-locality');
            }, 500);
        }

        public searchKeyDown(e: KeyboardEvent) {
            if (e.keyCode == 13) {
                this.closeSearchBox();
            }
        }

        public isLightScheme() {
            return this.$window.location.hash.substring(0, 8) == '#!/login' || this.$window.location.hash.substring(0, 6) == '#!/map';
        }

        public logOff() {
            this.user = null;
            this.userService.removeAccessToken();
            this.cookiesService.deleteCookie('company');
            this.$window.location.href = '/#!/login?redirectUrl=' + encodeURIComponent(this.$window.location.pathname);
        }

        private loadMapSettings() {
            this.mapSettings = <MapSettings>angular.fromJson(this.cookiesService.readCookie("mapSettings"));
            if (this.mapSettings == null) {
                this.mapSettings = new MapSettings();
            }
        }
    }

    NavigationController.$inject = ['$scope', 'UserService', '$window', '$location', 'CookiesService', '$route', 'TextService', 'CompanyService', 'OrganizationSettingsService', 'OrganizationService', '$q', '$rootScope', '$timeout'];

    angular
        .module('eseebase')
        .controller('NavigationController', NavigationController);
}
